import { useState } from "react";
import styled from 'styled-components';
import { Modal, Button, LoadingIcon } from '@prosolve/common-components-ui'
import useDataTextToSpeech from '../../../../dataHooks/useDataTextToSpeech';
import useSnackbar from '../../../../hooks/useSnackbar';

const Header = styled.div`
  display: flex;
  align-items: center;
  color: #565656;
  font-weight: bold;
`

const Title = styled.div`
  font-size: 22px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`

const QuestionText = styled.div`
  font-style: italic;
  color: #565656;
  padding: 10px;
  background: #f8f9fc;
  border: 1px solid #dedede;
  border-radius: 5px;
`

export default ({
  assessmentName,
  questionId,
  questionText,
  onClose,
  onSuccess
}) => {
  const snackbar = useSnackbar();

  const { generateQuestionAudio } = useDataTextToSpeech();

  const [isBusy, setIsBusy] = useState(false)

  const onSubmit = async () => {
    if (isBusy) {
      return;
    }
    try {
      setIsBusy(true)

      const result = await generateQuestionAudio({ assessmentName, questionId, questionText })

      if (result && result.success) {
        snackbar.newMessage({ message: 'Audio file generated. Save the assessment to keep the audio link.', severity: 'success' })
        onSuccess(result.fileUrl)
      } else {
        snackbar.newMessage({ message: 'Failed to generate text-to-speech audio', severity: 'failure' })
        setIsBusy(false)
      }
    } catch (e) {
      console.log(e)
      snackbar.newMessage({ message: 'Failed to generate text-to-speech audio', severity: 'failure' })
      setIsBusy(false)
    }
  }

  const TitleComponent = (
    <Header>
      <Title>
        {'Generate Question Audio'}
      </Title>
    </Header>
  )

  const baseButtonStyle = {
    padding: '10px',
    fontSize: '18px',
    borderRadius: '10px',
    width: '100px'
  }

  const FooterComponent = (
    <ButtonsContainer>
      <Button style={baseButtonStyle} onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button style={{ ...baseButtonStyle, fontWeight: 'bold', position: 'relative' }} onClick={onSubmit} $colored={true} $disabled={isBusy}>
        {
          isBusy ?
          <>
            &nbsp;
            <div style={{ position: 'absolute', top: '3px' }}>
              <LoadingIcon />
            </div>
          </>
          :
          'Generate'
        }
      </Button>
    </ButtonsContainer>
  )

  return (
    <Modal
      title={TitleComponent}
      isAutoHeight={true}
      closeOnOffClick={false}
      footer={FooterComponent}
      onClose={onClose}
    >
      <Content>
        <div>{'This will generate a text-to-speech audio file for the question below and replace any existing audio for this question.'}</div>
        <QuestionText>{questionText}</QuestionText>
        <div style={{ marginTop: '20px' }}>{'Do you wish to proceed?'}</div>
      </Content>
    </Modal>
  )
}
